import Vue from "vue";

const mutations = {
  addTabGroup(state, { groupId, tabGroup }) {
    state.tabGroups[groupId] = tabGroup;
  },
  removeTabFromGroups(state, tabId) {
    for (const gid of Object.keys(state.tabGroups)) {
      const arr = state.tabGroups[gid]
      const i = Array.isArray(arr) ? arr.indexOf(tabId) : -1
      if (i !== -1) {
        arr.splice(i, 1)
        if (arr.length === 0) {
          if (Vue && Vue.delete) Vue.delete(state.tabGroups, gid)
          else delete state.tabGroups[gid]
        } else {
          state.tabGroups[gid] = arr.slice()
        }
        break
      }
    }
  },
  clearTabGroups(state) {
    state.tabGroups = {}
  },
};

export default mutations;